import { combineReducers } from 'redux';

import sso from './sso';

export default combineReducers({
  sso
});
